import styled from 'styled-components';

export const Container = styled.div``;

export const Actions = styled.div`
  display: flex;
  margin-top: 2.5rem;

  > button {
    width: 6rem;
    margin-right: 0.5rem;
  }
`;

export const Message = styled.p`
  margin: 0;
`;
